const jobFilters = require('./job-filters');

const roles = require('./roles');

const addDeviceToken = require('./add-device-token');
const addLeadTimeTaskBody = require('./add-lead-time-task-body.json');
const addRelevantTaskBody = require('./add-relevant-task-body.json');
const changePassword = require('./change-password');
const changePasswordErrors400 = require('./change-password-errors-400.json');
const changePasswordErrors401 = require('./change-password-errors-401.json');
const createHomeowner = require('./create-homeowner.json');
const createInstallerBody = require('./create-installer-body');
const createInstallerQuery = require('./create-installer-query');
const createUser = require('./create-user');
const createUserAdmin = require('./create-admin');
const createUserSystemAdmin = require('./create-user-system-admin');
const deleteRelevantTaskQuery = require('./delete-relevant-task-query.json');
const deleteUser = require('./delete-user.json');
const getBuilderNotificationsSettings = require('./read-builder-notifications-settings.json');
const getFilterSettings = require('./get-filter-settings.json');
const getLeadTimeTasks = require('./get-lead-time-tasks.json');
const getRelevantTasks = require('./get-relevant-tasks.json');
const getSubNotificationsSettings = require('./read-sub-notifications-settings.json');
const getTokenQuery = require('./get-token-query.json');
const impersonate = require('./impersonate');
const listUserQuery = require('./list-user-query.json');
const listBuildersUserQuery = require('./list-builders-user-query.json');
const listAdminsUserQuery = require('./list-admins-user-query.json');
const listUsers = require('./list-users');
const login = require('./login.json');
const loginErrors401 = require('./login-errors-401.json');
const logout = require('./logout.json');
const magicLink = require('./magic-link');
const NotFoundEntity404 = require('./not-found-entity-404.json');
const sendContactBody = require('./send-contact-body.json');
const setupInstaller = require('./setup-installer.json');
const updateFilterSettings = require('./update-filter-settings.json');
const updateGlobalEventsNotifications = require('./update-global-settings-notifications.json');
const updateHomeowner = require('./update-homeowner.json');
const updateLeadTimeTaskBody = require('./update-lead-time-task-body.json');
const updateLocationUserBody = require('./update-location-user-body.json');
const updateNotificationSettings = require('./update-notification-settings.json');
const updateNotificationSettingsRelevantTasks = require('./update-notification-settings-relevant-tasks.json');
const updatePermissionsBuilder = require('./update-permissions-builder.json');
const updatePermissionsSystemAdmin = require('./update-permissions-system-admin.json');
const updatePermissionsSub = require('./update-permissions-sub.json');
const updateRelevantTaskQuery = require('./update-relevant-task-query.json');
const updateSelf = require('./update-self.json');
const updateUser = require('./update-user.json');
const updateSystemAdminUser = require('./update-system-admin.json');
const usersParams = require('./users-params.json');
const validateDemoUserBody = require('./validate-demo-user.json');
const viewHomeownerCommunitiesQuery = require('./view-homeowner-communities-query.json');
const viewHomeownersQuery = require('./view-homeowners-query.json');
const viewUserRecentActivityQuery = require('./view-recent-activity-query.json');
const addDeviceTokenQuery = require('./add-device-token-query.json');
const featureToggleRequestArray = require('./feature-toggle-request-array.json');

module.exports = {
  ...jobFilters,
  ...roles,
  addDeviceToken,
  addDeviceTokenQuery,
  addLeadTimeTaskBody,
  addRelevantTaskBody,
  changePassword,
  changePasswordErrors400,
  changePasswordErrors401,
  createHomeowner,
  createInstallerBody,
  createInstallerQuery,
  createUser,
  createUserAdmin,
  createUserSystemAdmin,
  updateSystemAdminUser,
  listAdminsUserQuery,
  deleteRelevantTaskQuery,
  deleteUser,
  getBuilderNotificationsSettings,
  getFilterSettings,
  getLeadTimeTasks,
  getRelevantTasks,
  getSubNotificationsSettings,
  getTokenQuery,
  impersonate,
  listUserQuery,
  listBuildersUserQuery,
  listUsers,
  login,
  loginErrors401,
  logout,
  magicLink,
  NotFoundEntity404,
  sendContactBody,
  setupInstaller,
  updateFilterSettings,
  updateGlobalEventsNotifications,
  updateHomeowner,
  updateLeadTimeTaskBody,
  updateLocationUserBody,
  updateNotificationSettings,
  updateNotificationSettingsRelevantTasks,
  updatePermissionsBuilder,
  updatePermissionsSub,
  updatePermissionsSystemAdmin,
  updateRelevantTaskQuery,
  updateSelf,
  updateUser,
  usersParams,
  validateDemoUserBody,
  viewHomeownerCommunitiesQuery,
  viewHomeownersQuery,
  viewUserRecentActivityQuery,
  featureToggleRequestArray,
};
